import { EmeraldError } from 'src/common/api/emerald-error';

import {
  CASHIER_BARCODE_IN_TRANSACTION,
  INVALID_BARCODE,
} from '../../common/api/business-error-codes';
import { DataAddType } from '../../common/enumerations/data-add-type';
import { IDataInformation } from '../../common/interfaces/dtos/IDataInformation';
import { IItemInputData } from '../../common/interfaces/IItemInputData';
import { addCouponLineItem } from '../../coupons/business-logic/add-coupon-line-item';
import { IAddCouponData } from '../../coupons/dto/IAddCouponData';
import { setLoyaltyCustomer } from 'src/customer-loyalty/business-logic/set-customer';
import { addLookupLineItem } from '../../items-list/business-logic/add-lookup-line-item';
import { performBarcodeTenderAdd } from 'src/tendering/business-logic/barcode-tender-add';
import { transactionAdd } from './transaction-add';

export const addTransactionDataLogic = async (
  dataInformation: IDataInformation,
  inputData: IItemInputData,
  action: string = 'Sell',
): Promise<void> => {
  switch (dataInformation.type) {
    case DataAddType.Item:
      return performLineItemAdd(inputData, dataInformation, action);

    case DataAddType.Customer:
      return performCustomerAdd(inputData);
    // commandHandler = GetCustomerAddCommandHandler(dataInformation);
    // break;
    case DataAddType.CustomerAlternateIDAndPIN:
      throw new EmeraldError('Not Implemented', 'Customer Barcode handler not implemented');
    // commandHandler = GetAddCustomerByAlternateIdWithValidationCommandHandler(dataInformation);
    // break;
    case DataAddType.Transaction:
      return transactionAdd(inputData, dataInformation);
    // commandHandler = GetAddTransactionOptionsCommandHandler(dataInformation);
    case DataAddType.Tender:
      return performBarcodeTenderAdd(dataInformation);

    case DataAddType.Coupon:
    case DataAddType.DatabarCoupon:
      return performCouponAdd(inputData);
    case DataAddType.Giftreceipt:
      throw new EmeraldError('Not Implemented', 'Gift receipt Barcode handler not implemented');
    // commandHandler = GetGiftReceiptCommandHandler(dataInformation);
    // break;
    case DataAddType.Group:
      throw new EmeraldError('Not Implemented', 'Group Barcode handler not implemented');
    // commandHandler = GetGroupLookupCommandHandler(dataInformation);
    // break;
    case DataAddType.Cashier:
      throw new EmeraldError(
        CASHIER_BARCODE_IN_TRANSACTION,
        'Cashier barcode cannot be scanned at this stage',
      );
    case DataAddType.DriverLicense:
      throw new EmeraldError(INVALID_BARCODE, 'Invalid Barcode');
    default:
      return performLineItemAdd(inputData, dataInformation, action);
  }
};

const performLineItemAdd = async (
  inputData: IItemInputData,
  dataInformation: IDataInformation,
  action: string,
): Promise<void> => {
  return addLookupLineItem({
    inputData,
    itemId: dataInformation.id || dataInformation.scanData,
    isWeightEmbeddedInBarcode: dataInformation.isWeightEmbeddedInBarcode,
    action,
  });
};

const performCouponAdd = async (inputData: IItemInputData): Promise<void> => {
  const addCouponDto: IAddCouponData = {
    scanData: inputData.itemId,
    entryMethod: inputData.entryMethod,
    quantity: inputData.quantity,
  };
  return addCouponLineItem(addCouponDto);
};

const performCustomerAdd = async (inputData: IItemInputData): Promise<void> => {
  return setLoyaltyCustomer(
    {
      consumerAccountNumber: undefined,
      identifiers: [
        {
          fieldName: 'loyaltyCard',
          fieldValue: inputData.itemId ?? '',
        },
      ],
    },
    inputData.entryMethod ?? 'Keyed',
    true,
  );
};
